import { render, staticRenderFns } from "./Create-User.vue?vue&type=template&id=5e07f190"
import script from "./Create-User.vue?vue&type=script&lang=js"
export * from "./Create-User.vue?vue&type=script&lang=js"
import style0 from "./Create-User.vue?vue&type=style&index=0&id=5e07f190&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports